export default __webpack_public_path__ + "static/media/service-app.aa63cb24.svg";